// extracted by mini-css-extract-plugin
export default {"main":"LoadingObras_main__EHUQg","header":"LoadingObras_header__RttsG","midle":"LoadingObras_midle__Be+gB","footer":"LoadingObras_footer__avZoX"};